<template>
  <div id="add-form">
    <div class="title-bar">
      <router-link class="back-link" to="/">
        <a-icon type="arrow-left" />
      </router-link>
      <h1>Add New Form Mapping</h1>
    </div>
    <a-form>
      <a-form-item label="Mapping Type" :label-col="{ span: 5 }" :wrapperCol="{ span: 13 }">
        <a-select
          v-if="!selectedMappingType"
          placeholder="Select Mapping Type"
          size="large"
          @change="changeMappingType"
        >
          <a-select-option v-for="mappingType in mappingTypes" :key="mappingType">{{ mappingType }}</a-select-option>
        </a-select>
        <div class="mapping-type-text" v-else>{{ selectedMappingType }}</div>
      </a-form-item>
    </a-form>
    <add-facebook-form v-if="selectedMappingType == 'Facebook'"></add-facebook-form>
    <add-other-form v-if="selectedMappingType == 'Google/Other'"></add-other-form>
    <add-snapchat-form  v-if=" selectedMappingType && selectedMappingType.toLowerCase() == 'snapchat'"></add-snapchat-form>
  </div>
</template>

<script>
import AddFacebookForm from "@/components/AddFacebookForm";
import AddSnapchatForm from "@/components/AddSnapchatForm";
import AddOtherForm from "@/components/AddOtherForm";

export default {
  components: {
    AddFacebookForm,
    AddOtherForm,
    AddSnapchatForm,
  },
  computed: {},
  data() {
    return {
      selectedMappingType: null,
      mappingTypes: ["Facebook", "Google/Other", "Snapchat"],
    };
  },
  methods: {
    changeMappingType(value) {
      this.selectedMappingType = value;
    },
  },
  mounted() {
    // Access the current route object
    // console.log(route);

    // Get the 'code' query parameter
    this.selectedMappingType = this.$route.query.mapType;
  },
};
</script>

<style lang="scss" scoped>
#add-form {
  display: flex;
  flex-direction: column;
}

.mapping-type-text {
  font-weight: 700;
}
</style>
